import React from 'react';
import { Link } from '@resy/ui-kitchen';
import {
  arrayOf,
  func,
  shape,
  string,
} from 'prop-types';
import IconMobile from '../../../images/member-week/icon-communication-mobile.svg';
import IconOffers from '../../../images/member-week/icon-membership-offers.svg';
import IconCard from '../../../images/member-week/icon-business-card.svg';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexShopSmallEnrollOffer.scss';

const AmexShopSmallEnrollOffer = (
  {
    enrollOfferConfig: {
      title,
      steps,
      fineprint,
      enroll_link: enrollLink,
      learn_more_link: learnMoreLink,
    },
    handleTagging,
    scrollTo,
    tagConfig,
    toggleTerms,
  }
) => {
  const {
    enroll_offer: {
      learn_more_link: {
        event_name: learMoreEventName,
        utm: learMoreUtm,
      },
      enroll_link: {
        event_name: enrollLinkEventName,
      },
    },
  } = tagConfig;

  const handleScroll = (url) => {
    const currentHash = url.replace('#', '');
    toggleTerms(currentHash);
    setTimeout(() => {
      scrollTo(url);
    }, 100);
  };

  const displayCTA = (cta, name) => {
    const { label, url } = cta;
    switch (name) {
      case 'enroll':
        return (
          <Link
            className="AmexShopSmallEnrollOffer__CTA"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            key={label}
            onClick={() => { handleTagging(enrollLinkEventName); }}
          >
            { label }
          </Link>
        );
      case 'termsApply':
        return (
          <Link
            className="AmexShopSmallEnrollOffer__link"
            key={label}
            href={url}
            variant="no-style"
            onClick={() => { handleScroll(url); }}
          >
            { label }
          </Link>
        );
      case 'learnMore':
      default:
        return (
          <Link
            className="AmexShopSmallEnrollOffer__link"
            href={`${url}${learMoreUtm}`}
            target="_blank"
            key={label}
            onClick={() => { handleTagging(learMoreEventName); }}
          >
            { label }
          </Link>
        );
    }
  };

  const stepIcons = [
    <IconMobile aria-hidden="true" />,
    <IconOffers aria-hidden="true" />,
    <IconCard aria-hidden="true" />,
  ];

  const displaySteps = (step, i) => {
    const sanitizedStepText = sanitizeString(step?.text);
    return (
      <li key={step.text}>
        <div className="AmexShopSmallEnrollOffer__steps__icon">
          {stepIcons[i]}
        </div>
        <p className="AmexShopSmallEnrollOffer__steps__content">
          <span
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedStepText,
            }}
          />
          {step.link && displayCTA(step.link, step.link.name)}
        </p>
      </li>
    );
  };

  const sanitizedTitle = sanitizeString(title);
  const sanitizedFineprint = sanitizeString(fineprint);

  return (
    <div className="AmexShopSmallEnrollOffer">
      <div className="AmexShopSmallEnrollOffer__wrapper">
        <div className="AmexShopSmallEnrollOffer__steps-wrapper">
          <h3
            className="AmexShopSmallEnrollOffer__subtitle"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedTitle,
            }}
          />
          <ol className="AmexShopSmallEnrollOffer__steps">
            {steps.map((step, i) => displaySteps(step, i))}
          </ol>

          {displayCTA(enrollLink, 'enroll')}
          <p className="AmexShopSmallEnrollOffer__fineprint">
            <span
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedFineprint,
              }}
            />
            {displayCTA(learnMoreLink, 'learnMore')}
          </p>
        </div>
      </div>
    </div>
  );
};

AmexShopSmallEnrollOffer.propTypes = {
  enrollOfferConfig: shape({
    title: string,
    steps: arrayOf(shape({})),
    fineprint: string,
    enroll_link: shape({}),
    learn_more_link: shape({}),
  }).isRequired,
  handleTagging: func.isRequired,
  scrollTo: func.isRequired,
  tagConfig: shape({
    enroll_offer: shape({
      learn_more_link: shape({
        event_name: string,
        utm: string,
      }),
      enroll_link: shape({
        event_name: string,
      }),
    }),
  }).isRequired,
  toggleTerms: func.isRequired,
};

export default AmexShopSmallEnrollOffer;
